import { useState } from 'react';
import PropTypes from 'prop-types';
import {
  Box, Button, CircularProgress, Container
} from '@mui/material';
import { saveAs } from 'file-saver';
import { useDispatch } from 'react-redux';
import CardListTable from 'src/components/cards/CardListTable';
import FMSToolbar from 'src/common/FMSToolbar';
import NewCard from 'src/components/cards/NewCard';
import ScreenHeader from 'src/common/ScreenHeader';
import { setErrorInfo } from 'src/redux/modalSlice';
import { BASEAPI } from 'src/api/api';
import { DATE_FORMAT } from 'src/utils/constants';
import moment from 'moment';
import API_URL from 'src/api/apiConstants';
import DownloadIcon from '@mui/icons-material/FileDownloadOutlined';

const Cards = ({ location }) => {
  const dispatch = useDispatch();
  const [openModal, setOpenModal] = useState(false);
  const [searchText, setSearchText] = useState('');
  const [isLoading, setLoading] = useState(false);

  const handleSearch = (str) => setSearchText(str);

  const handleExport = () => {
    setLoading(true);
    BASEAPI.get(`${API_URL.cardList}?export=true`, { responseType: 'blob', timeout: 20000 })
      .then((res) => {
        if (res.status !== 200) {
          throw res;
        }
        const fileName = `cards ${moment().format(DATE_FORMAT.reportDateTime)}.xlsx`;
        saveAs(res.data, fileName);
      })
      .catch(() => {
        const errMsg = 'Error downloading the report. Try again later!';
        dispatch(setErrorInfo({ errorMsg: errMsg }));
      })
      .finally(() => {
        setLoading(false);
      });
  };

  return (
    <>
      <ScreenHeader title="Cards" />
      <Box
        sx={{
          backgroundColor: 'background.default',
          minHeight: '100%',
          py: 3
        }}
      >
        <Container maxWidth={false}>
          <FMSToolbar
            placeholder="Search Card/Vehicle"
            actionName="Add Card"
            onSearch={handleSearch}
            onAction={() => setOpenModal(true)}
            actionStyle={{ ml: 2 }}
          >
            <Button
              sx={{ ml: 'auto' }}
              disabled={isLoading}
              color="primary"
              size="large"
              startIcon={<DownloadIcon />}
              variant="contained"
              onClick={handleExport}
            >
              {isLoading ? <CircularProgress size={25} /> : 'Export'}
            </Button>
          </FMSToolbar>
          <NewCard open={openModal} handleClose={() => setOpenModal(false)} />
          <Box sx={{ pt: 3 }}>
            <CardListTable refreshData={location.state?.fromDashboard} searchText={searchText} />
          </Box>
        </Container>
      </Box>
    </>
  );
};

Cards.propTypes = {
  location: PropTypes.object
};

export default Cards;
